module.exports = __webpack_public_path__ + "static/media/timedoorSVG.554875cf.svg";